import {mainUrl} from '../config';
import Axios from 'axios';

export function getUserData(username: String, callback = (response: any) => { }) {
    console.log(mainUrl)
    Axios.get(`${mainUrl}/external_api/profile/${username}`, { withCredentials: true }).then((response) => {
        callback(response.data)
    }).catch(e => {
        JSON.stringify(e);
        callback(null);
    })
}